module.exports = __webpack_public_path__ + "img/culture_1.2b5f92a1.png";